const initFilter = () => {
    const filterInput = document.querySelector("[data-input-filter]");
    const itemsToFilterArray = document.querySelectorAll("[data-item-toggle]");
    const itemsTitleToFilterArray = document.querySelectorAll("[data-item-filter]");
    if (filterInput) {
        filterInput.addEventListener("keyup", (e) => {
            const inputText = e.target.value.toLowerCase();
            for (let i = 0; i < itemsTitleToFilterArray.length; i++) {
                if (itemsTitleToFilterArray[i].innerText.toLowerCase().includes(inputText)) {
                    itemsToFilterArray[i].classList.remove("not-visible");
                }
                else {
                    itemsToFilterArray[i].classList.add("not-visible");
                }
            }
        });
    }
};
